import React from 'react'
import Button from '../components/Button'
import AuthService from 'services/AuthService'
import inboxOff from '../assets/inbox-off.svg'
import inboxOn from '../assets/inbox-on.svg'

import {NavLink, useLocation} from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import {Col, Row} from '../components/Display'
import services from 'services'
import {Optional, User} from 'data/types'
import _ from 'lodash'

type AppPageContainerProps = {
  children: React.ReactNode
}

type NavItem = {
  pathname: string
  iconOff: string
  iconOn: string
  name: string
}

const navItems: NavItem[] = [{pathname: '/projects', iconOff: inboxOff, iconOn: inboxOn, name: 'Projects'}]

if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  navItems.push({pathname: '/user', iconOff: inboxOff, iconOn: inboxOn, name: 'Profile'})
}

function NavigationBar(props: {user: Optional<User>}) {
  const location = useLocation()
  return (
    <Col className="w-16 items-center bg-itx-primary-3">
      <Row className="justify-center flex-grow-0 flex-shrink-0 items-center justify-center w-16 h-16">
        <img className="w-15 h-15 object-cover" src="/white-logo.svg" alt="itx-logo" />
      </Row>
      <Col className="flex-1 mt-6">
        {navItems.map((item) => {
          const isSelected = location.pathname.startsWith(item.pathname)
          return (
            <NavLink className="w-10 h-10 pl-2 pt-2 mb-2 rounded bg-itx-primary-2" key={item.name} to={item.pathname}>
              <img alt={item.name} src={isSelected ? item.iconOn : item.iconOff} data-for={item.name.toLowerCase()} data-tip={item.name} />
            </NavLink>
          )
        })}

        {navItems.map((item) => (
          <ReactTooltip key={item.name} id={item.name.toLowerCase()} effect="solid" />
        ))}
      </Col>
      {props.user != null && (
        <div className="pb-4" data-for="logout" data-tip="Log out">
          <Button
            className="border-none"
            content={
              <Col className="justify-center items-center w-12 h-12 rounded-full text-base text-white bg-itx-primary-base shadow-md">
                {_(props.user.firstName).first() ?? ''}
                {_(props.user.lastName).first() ?? ''}
              </Col>
            }
            onClick={() => AuthService.logOut()}
          />
        </div>
      )}
      <ReactTooltip id="logout" effect="solid" />
    </Col>
  )
}

export function AppPageContainer(props: AppPageContainerProps) {
  const authService = services.getAuthService()
  const [user] = authService.user.hook()
  return (
    <Row className="flex-1">
      <NavigationBar user={user} />
      <Col className="flex-1 bg-gray-itx-light">{props.children}</Col>
    </Row>
  )
}
